import styled from 'styled-components';

// calc height is based on  100px (filter bar) + padding/margin
export const ContentWrapper = styled.div<{ horizontalLayout: boolean }>`
  height: auto;
  display: flex;
  flex-direction: column;
  min-height: ${(props) => (props.horizontalLayout ? 'unset' : '700px')};
  flex-grow: 1;
`;

//   overflow: ${(props) => (props.horizontalLayout ? 'unset' : 'hidden')};

// calc height based  on toolbar + footer + padding/margin
export const SectionWrapper = styled.div<{ horizontalLayout: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.horizontalLayout ? 'column' : 'row')};
  margin: 0 0 0 7px;
  flex: 1;
  gap: 10px;
  height: ${(props) => (props.horizontalLayout ? 'auto' : 'calc(100% - 68px)')};
  padding-top: 5px;
`;

export const BreadcrumbWrapper = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;

  .ant-breadcrumb {
    font-size: 14px;
    color: rgb(0 0 0 / 85%);
  }

  .ant-breadcrumb a {
    color: rgb(0 0 0 / 65%);
    text-decoration: none;
  }

  .ant-breadcrumb a:hover {
    color: rgb(0 0 0 / 85%);
    text-decoration: underline;
  }
`;
